import { useHandler } from "@/hooks";
import { useNavigate, useSearch } from "@tanstack/react-router";

export function useTabNavigation({
  projectId,
  snapshotId,
}: {
  projectId: string;
  snapshotId: string;
}) {
  const navigate = useNavigate();
  const tabMapping = {
    brainstorm: "spec",
    code: "code",
    preview: "preview",
    trace: "trace",
  };

  const searchParams = useSearch({
    strict: false,
    select: (search) =>
      search as { tab?: string; file?: string; traceId?: string } | undefined,
  });

  const currentTab = searchParams?.tab ?? "spec";
  const computedActiveTab =
    Object.keys(tabMapping).find(
      (key) => tabMapping[key as keyof typeof tabMapping] === currentTab,
    ) || "brainstorm";

  const navigateTab = useHandler((tab: string) => {
    if (!projectId) {
      return;
    }

    switch (tab) {
      case "brainstorm":
        navigate({
          to: "/codegen/$projectId/filesystem/$snapshotId",
          params: {
            projectId,
            snapshotId,
          },
          search: { tab: "spec" },
        });
        break;
      case "code": {
        // TODO
        //   Performance tweak:
        //   Access the store directly to get the current files,
        //   then use the first file's filename in the search params
        // const snapshot = selectSnapshotFilesFromState(
        //   useFilesystemStore.getState(),
        //   snapshotId,
        // );
        // const currentFiles = snapshot?.files ?? [];
        // ^^^ use the last modified file's filename???
        navigate({
          to: "/codegen/$projectId/filesystem/$snapshotId",
          params: {
            projectId,
            snapshotId,
          },
          // TODO - Add the `file` query param here
          search: { tab: "code" },
        });
        break;
      }
      case "preview":
        navigate({
          to: "/codegen/$projectId/filesystem/$snapshotId",
          params: {
            projectId,
            snapshotId,
          },
          search: { tab: "preview" },
        });
        break;
      case "trace":
        navigate({
          to: "/codegen/$projectId/filesystem/$snapshotId",
          params: {
            projectId,
            snapshotId,
          },
          search: { tab: "trace" },
        });
        break;
    }
  });

  return {
    navigateTab,
    computedActiveTab,
  };
}
